import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';
import ComponentManager from '@/Management/ComponentManager';
import PrincipalHistorizationSelectionItemT from '@/Controls/PrincipalHistorizationSelectionItem';

export default class PrincipalHistorizationSelectionItemsBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.principalHistorizationSelectionItems = {
            init: (element: HTMLElement, valueAccessor: () => any) => {
                let PrincipalHistorizationSelectionItem = ComponentManager.getControl<typeof PrincipalHistorizationSelectionItemT>('PrincipalHistorizationSelectionItem');

                let selection = $(element);
                let options = valueAccessor();
                let parent = options.parent;
                let items = options.items;

                function onItemsChange(items) {
                    selection.find('li').remove();
                    parent.elements = [];

                    for (let i = 0; i < items.length; i++) {
                        let principalHistorizationSelectionItem = new PrincipalHistorizationSelectionItem(items[i], $('<li>').appendTo(selection));
                        let tuple = principalHistorizationSelectionItem.getTuple();

                        parent.elements.push(principalHistorizationSelectionItem);
                    }
                }

                let subscription = items.subscribe(onItemsChange);
                ko.utils.domNodeDisposal.addDisposeCallback(selection[0], () => {
                    subscription.dispose();
                });
                onItemsChange(items());
            }
        };
    }
}